import { render, staticRenderFns } from "./ClientBanks.vue?vue&type=template&id=42074816"
import script from "./ClientBanks.vue?vue&type=script&lang=js"
export * from "./ClientBanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports